<template>
  <div>
    <LoadingPage v-if="loadingData"></LoadingPage>
    <v-container
      v-if="!loadingData"
      fluid
      :fill-height="noFiles"
      :style="{
        maxWidth: '500px'
      }"
    >
      <v-row justify="end">
        <v-col :cols="noFiles ? 12 : 11" :class="noFiles ? 'py-0 px-6' : 'py-0 px-1'">
          <v-card class="pa-1 ma-0 mb-2">
            <v-textarea
              v-model="articleTitle"
              ref="articleTitle"
              outlined
              hide-details="auto"
              auto-grow
              rows="1"
              label="По какому поводу пишем?"
            ></v-textarea>
          </v-card>
        </v-col>

        <v-col cols="12" :class="noFiles ? 'py-0 px-6 mx-3' : 'py-0 px-1 mx-3'">
          <v-row justify="end">
            <v-card class="pa-1 ma-0 mb-4 mr-0">
              <ArticleDatePicker v-model="eventDate"></ArticleDatePicker>
            </v-card>
          </v-row>
        </v-col>

        <v-col v-if="!noFiles" cols="12" class="py-0 px-1">
          <v-row justify="center" class="mx-5">
            <v-btn color="success" small dark class="mb-2" @click="addFiles(0)">
              <v-icon>mdi-image-plus</v-icon>
            </v-btn>
            <v-btn color="success" small dark class="mb-2 ml-3" @click="addYoutubeVideo(0)">
              <v-icon>mdi-youtube</v-icon>
            </v-btn>
          </v-row>
        </v-col>

        <v-col v-for="(file, index) in files" :key="file.name" cols="12" class="py-0 px-1 my-2">
          <v-card class="pa-1 ma-0">
            <div>
              <v-textarea
                v-model="file.text"
                outlined
                hide-details="auto"
                auto-grow
                rows="2"
                class="mb-1"
              ></v-textarea>
              <UploadFilePreview
                v-if="file.uploadStatus != 'uploaded'"
                :preview="file.preview"
                :type="file.type"
                :uploadProgress="file.uploadProgress"
                :uploadStatus="file.uploadStatus"
                :errorMessage="file.errorMessage"
                @reload_file="reloadFileHandler(file)"
              ></UploadFilePreview>

              <MediaComponent
                v-if="file.uploadStatus == 'uploaded'"
                :media="file.media"
                :slot-width="windowWidth > 500 ? 490 : windowWidth - 10"
                :slot-height="windowHeight - 150"
              ></MediaComponent>
            </div>

            <InfoPairManagementMenu
              :first="index == 0"
              :last="index == files.length - 1"
              @delete_infopair="deleteFileHandler(file)"
              @move_infopair_up="moveFileUpHandler(file)"
              @move_infopair_down="moveFileDownHandler(file)"
            ></InfoPairManagementMenu>
          </v-card>

          <v-row justify="center" class="mx-5">
            <v-btn color="success" small dark class="mt-2" @click="addFiles(index + 1)">
              <v-icon>mdi-image-plus</v-icon>
            </v-btn>
            <v-btn color="success" small dark class="mt-2 ml-3" @click="addYoutubeVideo(index + 1)">
              <v-icon>mdi-youtube</v-icon>
            </v-btn>
          </v-row>
        </v-col>

        <v-col v-if="noFiles" cols="12" :class="getPadding">
          <v-row align="center" justify="center">
            <v-btn x-large color="success" dark class="my-5" @click="addFiles(0)">
              <v-icon large left class="ml-2 mr-6">mdi-image-plus</v-icon>картинки и видео
            </v-btn>
            <v-btn small color="success" dark class="my-1" @click="addYoutubeVideo(0)">
              <v-icon large left class="ml-2 mr-6">mdi-youtube</v-icon>видео с
              Youtube
            </v-btn>
          </v-row>
        </v-col>
        <v-col v-if="!noFiles" cols="12" class="my-5 py-0">
          <v-row align="center" justify="center">
            <v-btn
              color="primary"
              x-large
              dark
              :loading="apiLoadingData"
              @click="submitArticle"
            >Сохранить</v-btn>
            <v-alert v-model="showErrorAlert" type="error" dismissible>
              {{
              errorMessage
              }}
            </v-alert>
          </v-row>
        </v-col>
      </v-row>
      <ConfirmDialog ref="confirm"></ConfirmDialog>
      <InputFileHidden ref="files" @change="handleFileUploads" />
      <YoutubeCodeDialog
        :dialog="youtubedialog"
        @save="saveYoutubeCodeHandler"
        @close="youtubedialog = false"
      ></YoutubeCodeDialog>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment'
import { authComputed } from '@/store/helpers.js'
import { editingLogicMixin } from '@/components/mixins/editing'
import { uploadFilesMixin } from '@/components/mixins/uploadFiles'
import { vueWindowSizeMixin } from 'vue-window-size'
import APIService from '@/apiservices/APIService.js'

import Vue from 'vue'

import InputFileHidden from '@/components/InputFileHidden.vue'
import InfoPairManagementMenu from '@/components/InfoPairManagementMenu.vue'
import UploadFilePreview from '@/components/UploadFilePreview.vue'
import MediaComponent from '@/components/MediaComponent.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import LoadingPage from '@/components/LoadingPage.vue'
import YoutubeCodeDialog from '@/components/YoutubeCodeDialog.vue'
import ArticleDatePicker from '@/components/ArticleDatePicker.vue'

export default {
  props: ['article_id'],
  components: {
    ArticleDatePicker,
    InputFileHidden,
    InfoPairManagementMenu,
    UploadFilePreview,
    MediaComponent,
    ConfirmDialog,
    LoadingPage,
    YoutubeCodeDialog
  },
  mixins: [editingLogicMixin, uploadFilesMixin, vueWindowSizeMixin],
  data() {
    return {
      articleTitle: '',

      // Раньше это была просто дата, а теперь мы переходим на массив из двух элементов [start_event_dadte, event_date]
      // Расширяем массив еще и на описание промежутка времени [start_event_dadte, event_date, event_date_title]
      eventDate: [null, new Date(), null],

      article: null,
      infopairs: [],
      loadingData: false,

      youtubedialog: false
    }
  },

  computed: {
    ...authComputed,

    noFiles() {
      if (this.files.length == 0) {
        return true
      }
      return false
    },

    getPadding() {
      if (this.noFiles) {
        return 'py-0 px-6'
      } else {
        return 'py-0 px-1'
      }
    }
  },
  created() {
    if (this.article_id) {
      this.loadingData = true
      APIService.getArticle(this.article_id)
        .then(({ data }) => {
          this.article = data
          this.initData()
          this.loadingData = false
        })
        .catch(error => {
          console.log('There was an error in getArticle API call:', error)
        })
    }
  },
  mounted() {
    //this.$refs.articleTitle.focus()
  },
  methods: {
    getFilePosition(name) {
      return this.files.findIndex(x => x.name == name)
    },

    updateProperties(file) {
      Vue.set(this.files, this.getFilePosition(file.name), file)
    },

    resetProperties(file) {
      file.errorMessage = null
      file.uploadProgress = 0
      file.uploadStatus = ''
    },
    uploadComplete(file) {
      file.uploadStatus = 'uploaded'
      file.isNew = true
      let media = {}
      if (file.type.indexOf('image') >= 0) {
        media.type = 'picture'
        media.filename = file.name
        media.width = file.width
        media.height = file.height
        media.s3bucket = 'bannov-land-blog-uploads'
      } else {
        media.type = 'video'
        media.filename = file.name
        media.s3bucket = 'bannov-land-blog-uploads'
      }
      file.media = media
      this.updateProperties(file)
    },
    reloadFileHandler(file) {
      this.resetProperties(file)
      this.updateProperties(file)
      this.submitFile(file)
    },
    deleteFileHandler(file) {
      if (!file.isNew) {
        this.deleteData(APIService.deleteInfoPair, file.name)
      } else {
        this.dataDeleted(file.name)
      }
    },
    dataDeleted(id) {
      var list = this.files.filter(x => {
        return x.name != id
      })
      this.files = list
    },
    dataUpdated(article) {
      console.log('DATA UPDATED', article)

      this.$router.push('/article/' + article.id)
    },
    dataAdded(article) {
      console.log('DATA ADDED', article)

      this.$router.push('/article/' + article.id)
    },
    moveFileUpHandler(file) {
      let index = this.getFilePosition(file.name)
      if (index == 0) {
        return
      }
      let f1 = this.files[index - 1]
      let f2 = this.files[index]
      Vue.set(this.files, index - 1, f2)
      Vue.set(this.files, index, f1)
    },
    moveFileDownHandler(file) {
      let index = this.getFilePosition(file.name)
      if (index == this.files.length - 1) {
        return
      }
      let f1 = this.files[index]
      let f2 = this.files[index + 1]
      Vue.set(this.files, index, f2)
      Vue.set(this.files, index + 1, f1)
    },
    textCangedHandler(name, text) {
      let file = this.files[this.getFilePosition(name)]
      file.text = text
    },
    //// Методы связанные с добавлением кода youtube

    addYoutubeVideo(index) {
      this.youtubedialog = true
      this.uploadStartingFromIndex = index
    },

    saveYoutubeCodeHandler(youtubecode) {
      console.log('YOUTUBECODE', youtubecode)
      this.youtubedialog = false
      let media = {}
      media.type = 'youtubevideo'
      media.youtube_code = youtubecode
      let file = {
        text: '',
        name: youtubecode,
        media: media,
        uploadStatus: 'uploaded',
        isNew: true
      }
      this.files.splice(this.uploadStartingFromIndex, 0, file)
    },

    //
    // Методы связаннные с добавлением артикла в базу
    // Остальные методы и переменные для изменений в базе берутся из миксина editing.js
    //
    initData() {
      if (this.article) {
        this.articleTitle = this.article.title
        if (this.article.start_event_date) {
          this.eventDate = [
            new Date(this.article.start_event_date),
            new Date(this.article.event_date),
            this.article.event_date_title
          ]
        } else {
          this.eventDate = [
            null,
            new Date(this.article.event_date),
            this.article.event_date_title
          ]
        }

        this.files = []
        for (var i in this.article.infopairs) {
          let infopair = this.article.infopairs[i]
          let file = {}
          file.text = infopair.text
          file.name = infopair.id
          file.media = infopair.media
          file.uploadStatus = 'uploaded'
          file.isNew = false
          this.files.push(file)
        }
      }
    },

    newData() {
      let event_date = new Date(
        moment(new Date(this.eventDate[1])).format('YYYY-MM-DD')
      )
      let start_event_date
      if (this.eventDate[0]) {
        start_event_date = new Date(
          moment(new Date(this.eventDate[0])).format('YYYY-MM-DD')
        )
      } else {
        start_event_date = null
      }

      const apiData = {}

      apiData.journey = null
      apiData.title = this.articleTitle
      apiData.event_date = event_date
      apiData.start_event_date = start_event_date
      apiData.event_date_title = this.eventDate[2]
      apiData.media_pub_date = new Date()
      apiData.publication_date = null
      apiData.author = this.loggedUserPersonId
      apiData.infopairs = []
      for (let i = 0; i < this.files.length; i++) {
        let file = this.files[i]
        let infopair = {}
        infopair.id = 0
        infopair.position = i
        infopair.text = file.text ? file.text : ''
        infopair.media = file.media
        apiData.infopairs.push(infopair)
      }

      return apiData
    },

    setData() {
      console.log('EVENT DATE:', this.eventDate)
      let event_date = new Date(
        moment(new Date(this.eventDate[1])).format('YYYY-MM-DD')
      )
      let start_event_date
      if (this.eventDate[0]) {
        start_event_date = new Date(
          moment(new Date(this.eventDate[0])).format('YYYY-MM-DD')
        )
      } else {
        start_event_date = null
      }

      ////
      //// По каким то причинам серверная часть принимает далеко не все передающиеся при аапдейте артикла поля
      //// Плюс в сервверной части есть часть логики по публикации
      //// Это какая-то херня, но вот пока так живет
      ////

      const apiData = {}

      apiData.journey = null
      apiData.title = this.articleTitle

      apiData.event_date = event_date
      apiData.start_event_date = start_event_date
      apiData.event_date_title = this.eventDate[2]
      apiData.media_pub_date = new Date()
      //apiData.publication_date = null
      apiData.author = this.loggedUserPersonId
      apiData.infopairs = []
      for (let i = 0; i < this.files.length; i++) {
        let file = this.files[i]
        let infopair = {}
        if (!file.isNew) {
          infopair.id = file.name
        } else {
          infopair.id = 0
        }
        infopair.position = i
        infopair.text = file.text ? file.text : ''
        infopair.media = file.media

        apiData.infopairs.push(infopair)
      }
      console.log('SET DATA:', apiData)

      return apiData
    },

    setFreshData() {},

    submitArticle() {
      if (this.article) {
        this.updateData(APIService.updateArticle, this.article.id)
      } else {
        this.addData(APIService.createArticle)
      }
    }
  }
}
</script>

<style></style>
